export default __webpack_public_path__ + "solutionIcon4.82490f8.png";